<!-- Template -->

<template> 
    <ul class="nav nav-tabs horizontal">

        <li class="nav-item">
            <a class="nav-link"
                :class="{ active: section === 'past' }"
                @click.prevent="section = 'past'">
                Past
            </a>
        </li>

        <li class="nav-item">
            <a class="nav-link"
                :class="{ active: section === 'upcoming' }"
                @click.prevent="section = 'upcoming'">
                Upcoming
            </a>
        </li>

    </ul>
</template>

<!-- Script -->

<script>
    export default {
        name: 'ActivityNavigation',

        data() {
            return {
                section: 'past'
            };
        }
    }
</script>

